import React from "react";
import { Button, Stack, TextField } from "@mui/material";
import ListItem from "@mui/material/ListItem";

const EmailForm = ({
  newEmail,
  onNewEmailChanged,
  onNewEmailSubmit,
}) => {

  const handleSubmit = (event) => {
    event.preventDefault();
    onNewEmailSubmit();
  };

  return (
    <ListItem style={{
      width: "100%",
      padding: "5px 0",
    }}>
      <Stack
        component="form"
        onSubmit={handleSubmit}
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <TextField
          variant="standard"
          type="email"
          id="newEmail"
          value={newEmail}
          placeholder="Enter new email"
          onChange={onNewEmailChanged}
          fullWidth
          style={{ marginRight: "3em" }}
        />
        <Button
          variant="contained"
          type="submit"
          disabled={!newEmail}
        >
          Add
        </Button>
      </Stack>
    </ListItem>
  );
};

export default EmailForm;